
import BaseComponent from "./BaseComponent";


const {ccclass} = cc._decorator;

@ccclass
export default class BasePopUpLayer extends BaseComponent {
    
    addLayerTouchEvent() {
        this.initTouchEvent(this.node, true);
    }
}
